import { useEffect } from 'react';
import amplitude from '../services/amplitude';

export const useAmplitudeSearchPlateNumberHintPageView = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return;
    amplitude.searchPlateNumberHintPageView();
  }, [isOpen]);
};
